import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { getCurrentUser } from 'src/app/auth/adapters/knap'
import type { User } from 'src/app/auth/domain/models/user'
import { mapKnapUser } from 'src/app/auth/domain/use-cases/map-knap-user'
import { authKeys } from 'src/app/auth/queries/keys'

export interface IUseCurrentUserQueryParams {
  enabled: boolean
}

export const useCurrentUserQuery = (
  params: IUseCurrentUserQueryParams,
): UseQueryResult<User, Error> => {
  return useQuery({
    queryKey: authKeys.currentUser(),
    queryFn: async () => {
      const dto = await getCurrentUser()
      return mapKnapUser({ dto })
    },
    enabled: params.enabled,
    retry: false,
    staleTime: Infinity,
    meta: { silent: true },
  })
}
